<div role="document" class="modal-dialog" data-dismiss="modal">
  <div class="modal-content" style="border: 0rem">
    <div class="modal-body">
      <ng-content></ng-content>
    </div>
    <div class="modal-footer">
    </div>
  </div>
</div>